const SET_OPTIONS = 'gratis-app/SET_OPTIONS';

export default function reducer( state = {}, action ) {
    switch ( action.type ) {
        case SET_OPTIONS:
            return action.options;
        default:
            return state;
    }
}

export function setOptions( options ) {
    return {
        type: SET_OPTIONS,
        options
    };
}



// WEBPACK FOOTER //
// ./src/form/redux/modules/options.js